"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderModeContextProvider = void 0;
exports.useRenderMode = useRenderMode;
const react_1 = __importStar(require("react"));
const RenderModeContext = (0, react_1.createContext)(undefined);
const RenderModeContextProvider = ({ children, renderModeService, }) => {
    const renderMode = renderModeService.getRenderMode();
    return (react_1.default.createElement(RenderModeContext.Provider, { value: renderMode }, children));
};
exports.RenderModeContextProvider = RenderModeContextProvider;
RenderModeContextProvider.displayName = "RenderModeContextProvider";
function useRenderMode() {
    const renderMode = (0, react_1.useContext)(RenderModeContext);
    if (renderMode === undefined) {
        throw new Error(`The required "renderModeService" couldn't be found. Did you forget to wrap your component with <RenderModeContextProvider />?
<RenderModeContextProvider renderModeService={renderModeService}>
  <YOUR_COMPONENT />
</RenderModeContextProvider>`);
    }
    return renderMode;
}
//# sourceMappingURL=context.js.map